const exportBooking = {
	"requestedDeparture": "Requested Departure",
	"bookingOrderNumber": "Booking Order Number",
	"isContainsPerishableGoods": "This booking contains perishable goods",
	"loadProfile": "Load Profile",
	"flightNumber": "Flight Number",
	"pieces": "Pieces"
};

export { exportBooking };